// removed by extract-text-webpack-plugin
module.exports = {"controls":"delete-categories-modal__controls___1-yl5"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/manage-categories/delete-categories-modal.scss
// module id = 1341
// module chunks = 0